// extracted by mini-css-extract-plugin
module.exports = {"typography":"BalanceCard_typography__Rfy25","date":"BalanceCard_date__1uniO","sum":"BalanceCard_sum__1RYGX","noDebt":"BalanceCard_noDebt__2_cgR"};